/**
 * Normalise an exposure count from a form or a stored observation.
 *
 * 0 is a real value: "repeat until the window ends". The server sets it when it
 * turns a rise-to-set request into a time-window run, so `|| 1` (which turns 0
 * into 1) silently shortened all-night runs to a single pass on every edit.
 */
export function toExposureCount(value, fallback = 1) {
  if (value === '' || value === null || value === undefined) return fallback;
  const n = Number(value);
  return Number.isFinite(n) && n >= 0 ? Math.floor(n) : fallback;
}

export default toExposureCount;
